import React, { FC } from 'react';
import './styles.scss';

export const VerifyTalentCardSkeleton: FC = () => {
  return (
    <div className="verify-talent-card-skeleton pulse-fade">
      <div className="verify-talent-card-skeleton__preview">
        <div className="verify-talent-card-skeleton__section-one">
          <div className="verify-talent-card-skeleton__circle" />

          <div className="verify-talent-card-skeleton__section-one-first-block">
            <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--big" />
            <div className="verify-talent-card-skeleton__tile" />
            <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--fat" />
          </div>

          <div className="verify-talent-card-skeleton__section-one-second-block">
            <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--big" />
            <div className="verify-talent-card-skeleton__tile" />
          </div>
        </div>

        <div className="verify-talent-card-skeleton__section-two">
          <div className="verify-talent-card-skeleton__salary-exp">
            <div className="verify-talent-card-skeleton__tile" />
            <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--small" />
          </div>

          <div className="verify-talent-card-skeleton__speciality">
            <div className="verify-talent-card-skeleton__tile" />
            <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--small" />
          </div>
        </div>

        <div className="verify-talent-card-skeleton__section-three">
          <div className="verify-talent-card-skeleton__tile" />
          <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--small" />
          <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--small" />
          <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--tiny" />
        </div>

        <div className="verify-talent-card-skeleton__section-four">
          <div className="verify-talent-card-skeleton__rounded-square" />
          <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--xs" />
          <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--xxs" />
          <div className="verify-talent-card-skeleton__tile verify-talent-card-skeleton__tile--xxs" />
        </div>
      </div>
    </div>
  );
};
